import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'
import { ITableModel } from "helpers/types/types";
import { IDocumentGet } from "./types/types";

const initialState: ITableModel<IDocumentGet> = {
  items: [],
  totalCount: 0
};

const documentsSlice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    putDocuments: (state: ITableModel<IDocumentGet>, action: PayloadAction<ITableModel<IDocumentGet>>) => {
      state.totalCount = action.payload.totalCount;
      state.items = action.payload.items
    },
  },
});

export const { putDocuments } = documentsSlice.actions;

export default documentsSlice.reducer;
